import { SkeletonBlock, SkeletonText } from '@nucleus/web-theme-elements';
import React from 'react';
import styled from 'styled-components';

export const SermonExpandedListItemSkeleton = (): JSX.Element => {
  return (
    <Container>
      <MediaPlaceholder />
      <Meta>
        <SkeletonText width="20%" style={{ height: 10, marginBottom: 12 }} />
        <SkeletonText width="85%" style={{ height: 20, marginBottom: 8 }} />
        <SkeletonText width="65%" style={{ height: 20, marginBottom: 16 }} />
        <TextBlock>
          <SkeletonText width="100%" style={{ height: 12, marginBottom: 4 }} />
          <SkeletonText width="95%" style={{ height: 12, marginBottom: 4 }} />
          <SkeletonText width="70%" style={{ height: 12, marginBottom: 16 }} />
        </TextBlock>
        <SkeletonText width="30%" style={{ height: 10, marginBottom: 20 }} />
        <SkeletonBlock style={{ width: 140, height: 44, borderRadius: 8 }} />
      </Meta>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
`;

const MediaPlaceholder = styled(SkeletonBlock)`
  flex: 2 1 500px;
  max-width: 860px;
  aspect-ratio: 16 / 9;
  border-radius: 10px;
`;

const Meta = styled.div`
  flex: 1 2 300px;
  max-width: 860px;
  padding-left: 4.6%;

  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const TextBlock = styled.div``;
